import fsaActionCreatorFactory from "typescript-fsa";
import { TestEnvironment } from "interfaces/test-environments";

const actionCreator = fsaActionCreatorFactory("TEST_ENVIRONMENTS");

export const fetchTestEnvironments = actionCreator.async<
    { authenticated: boolean },
    TestEnvironment[]
>("FETCH_TEST_ENVIRONMENTS");
